// extracted by css-extract-rspack-plugin
export default {"modal":"WelcomeModal_modal__xvAkV","description":"WelcomeModal_description__hQfgh"};